import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { TodoEvents } from '../../state/todo/events';
import { TodoState } from '../../state/todo/state';
import { StreamInterface } from '@iwentsourcing/core/stream/stream-interface.js';
import { timedSignal } from '@iwentsourcing/core/utils/timedSignal.js';

@Component({
  selector: 'app-todo-list-create',
  templateUrl: './todo-list-create.component.html',
  styleUrls: ['./todo-list-create.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TodoListCreateComponent {
  stream = input.required<StreamInterface<TodoState, TodoEvents>>();

  async create(value: HTMLInputElement) {
    await this.stream().push(
      'create-todo',
      {
        title: value.value,
      },
      { signal: timedSignal() },
    );
    value.value = '';
  }

  keyUp(evt: KeyboardEvent, value: HTMLInputElement) {
    if (evt.key === 'Enter') {
      this.create(value);
    }
  }
}
